// import { KTCard } from '../../../../_metronic/helpers'
// import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
// import { Link } from 'react-router-dom'
// import clsx from 'clsx'
// import React from 'react'
// import { useAuth } from '../../auth'

// const features = (isPartner = false, isSupplyChainManager = false) => [
//   ...(isPartner
//     ? [
//       { name: 'Credit Buyer', icon: 'sponsor', to: 'credit-buyer' },
//       { name: 'Standard', icon: 'stanadrd', to: 'audit-standard' },
//       { name: 'Sc Manager', icon: 'SC Manager', to: 'sc-manager' },
//     ]
//     : [
//       { name: 'Content', icon: 'content', to: 'content' },
//       { name: 'Category', icon: 'category new_', to: 'category' },
//       { name: 'Items', icon: 'Item-1', to: 'items' },
//       { name: 'Pricing', icon: 'pricing', to: 'pricing' },
//       { name: 'Pricing Template', icon: 'pricing', to: 'pricing-template' },
//       // {name: 'Incentives', icon: 'incentive', to: 'incentives'},
//       { name: 'Process type', icon: 'process type', to: 'processing-routes' },
//       { name: 'Weight Scale', icon: 'weightscale ', to: 'weight-scale' },
//       { name: 'Certifications', icon: 'certificate', to: 'certifications' },
//       { name: 'Auditor', icon: 'audtor', to: 'auditor' },
//       { name: 'Product Testing', icon: 'testing', to: 'product-testing' },
//       { name: 'Point of Origin', icon: 'point of origin', to: 'point-of-origin' },
//       ...((isSupplyChainManager && [
//         {
//           name: 'Supply Chains',
//           icon: 'supply-chain',
//           to: 'supply-chains',
//         },
//         {
//           name: 'Transport',
//           icon: 'streetcar',
//           to: 'transport',
//         },
//       ]) ||
//         []),
//       // {name: 'Credit Buyer', icon: 'Credit Buyer', to: 'credit-buyer'},
//     ]),
// ]

// const Menu = () => {
//   const { isPartner, isSupplyChainManager } = useAuth()
//   console.log({ isPartner })
//   return (
//     <KTCard addCard={false}>
//       <div className='row g-xl-4'>
//         {features(isPartner, isSupplyChainManager).map((eachFeatures, eachIndex) => (
//           <div key={eachIndex + 1 + ''} className='col col-lg-2'>
//             <Link className={clsx('menu-link without-sub')} to={eachFeatures.to}>
//               <Card4
//                 // icon={`/media/svg/files/${eachFeatures.icon}.png`}
//                 icon={`/media/svg/files/${eachFeatures.icon}.png`}
//                 title={eachFeatures.name}
//                 description=''
//               />
//             </Link>
//           </div>
//         ))}
//       </div>
//     </KTCard>
//   )
// }

// const SettingsMenu = () => <Menu />

// export { SettingsMenu }



import { KTCard } from '../../../../_metronic/helpers'
import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React from 'react'
import { useAuth } from '../../auth'

const features = (isPartner = false, isSupplyChainManager = false, currentUser: any = {}) => [
  ...(isPartner
    ? [
      // { name: 'Credit Buyer', icon: 'sponsor', to: 'credit-buyer' },
      // { name: 'Commitment', icon: 'commitment', to: 'commitment' },
      { name: 'Audit standard', icon: 'stanadrd', to: 'audit-standard' },
      { name: 'App settings', icon: 'app settings', to: 'app-settings' },
      ...(currentUser?.userType !== 'CLIENT'
        ? [{ name: 'Sc manager', icon: 'SC Manager', to: 'sc-manager' }]
        : []
      ),
      // { name: 'Engagement', icon: 'engagment', to: 'engagement' },
    ]
    : [
      { name: 'Content', icon: 'content', to: 'content' },
      { name: 'Category', icon: 'catgeory', to: 'category' },
      { name: 'Item master', icon: 'FTS Item', to: 'items' },
      { name: 'Pricing', icon: 'FTS pricing', to: 'pricing' },
      { name: 'Pricing template', icon: 'FTS pricing', to: 'pricing-template' },
      // {name: 'Incentives', icon: 'incentive', to: 'incentives'},
      { name: 'Process master', icon: 'FTS process type', to: 'processing-routes' },
      { name: 'Weight scale', icon: 'FTS Weighscale', to: 'weight-scale' },
      { name: 'Certifications', icon: 'FTS Certifications', to: 'certifications' },
      { name: 'Auditor', icon: 'FTS Auditor', to: 'auditor' },
      // { name: 'Product Testing', icon: 'testing', to: 'product-testing' },
      // { name: 'Point of Origin', icon: 'point of origin', to: 'point-of-origin' },
      { name: 'Incentive', icon: 'FTS Incentive', to: 'incentive-settings' },
      // ...(isSupplyChainManager
      //   ? [{ name: 'Coupon', icon: 'point of origin', to: 'coupons-1' }]
      //   : []
      // ),
      // ...((isSupplyChainManager && [
      //   {
      //     name: 'Supply Chains',
      //     icon: 'supply-chain',
      //     to: 'supply-chains',
      //   },
      // ]) ||
      //   []),
      // {name: 'Credit Buyer', icon: 'Credit Buyer', to: 'credit-buyer'},
    ]),
]

const Menu = () => {
  const { isPartner, isSupplyChainManager, currentUser } = useAuth()
  console.log({ isPartner })
  return (
    <KTCard addCard={false}>
      <div className='row g-xl-4'>
        {features(isPartner, isSupplyChainManager, currentUser).map((eachFeatures, eachIndex) => (
          <div key={eachIndex + 1 + ''} className='col col-lg-2'>
            <Link className={clsx('menu-link without-sub')} to={eachFeatures.to}>
              <Card4
                // icon={`/media/svg/files/${eachFeatures.icon}.png`}
                icon={`/media/svg/files/${eachFeatures.icon}.png`}
                title={eachFeatures.name}
                description=''
              />
            </Link>
          </div>
        ))}
      </div>
    </KTCard>
  )
}

const SettingsMenu = () => <Menu />
export { SettingsMenu }